import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeft16, IcoChevronRight16 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { useFocusByDelta, useOrderedCanvasSuggestions } from '../../../store/suggestions-nav';
type FocusedNavHeaderProps = {
  suggestionId: string;
};
const FocusedNavHeader = t0 => {
  const $ = _c(30);
  const {
    suggestionId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.nav"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const ordered = useOrderedCanvasSuggestions();
  const focusByDelta = useFocusByDelta();
  let t2;
  if ($[1] !== suggestionId) {
    t2 = s => s.id === suggestionId;
    $[1] = suggestionId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const index = ordered.findIndex(t2);
  if (ordered.length <= 1 || index < 0) {
    return null;
  }
  let t3;
  if ($[3] !== focusByDelta || $[4] !== index || $[5] !== ordered) {
    t3 = delta => {
      focusByDelta(ordered, index, delta);
    };
    $[3] = focusByDelta;
    $[4] = index;
    $[5] = ordered;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const move = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = index === 0;
  let t6;
  if ($[9] !== move) {
    t6 = () => move(-1);
    $[9] = move;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <IconButton aria-label={t4} icon={IcoChevronLeft16} size="tiny" disabled={t5} onClick={t6} />;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = index + 1;
  let t9;
  if ($[15] !== ordered.length || $[16] !== t8) {
    t9 = <span className="text-caption-3 text-tertiary tabular-nums min-w-[36px] text-center">{t8} / {ordered.length}</span>;
    $[15] = ordered.length;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t(_temp2);
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = index >= ordered.length - 1;
  let t12;
  if ($[20] !== move) {
    t12 = () => move(1);
    $[20] = move;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12) {
    t13 = <IconButton aria-label={t10} icon={IcoChevronRight16} size="tiny" disabled={t11} onClick={t12} />;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t7 || $[28] !== t9) {
    t14 = <div className="absolute -top-4 right-3 z-10 flex items-center gap-1 px-1 py-0.5 rounded-md border border-accent/30 bg-primary shadow-sm">{t7}{t9}{t13}</div>;
    $[26] = t13;
    $[27] = t7;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default FocusedNavHeader;
function _temp($) {
  return $.prev;
}
function _temp2($_0) {
  return $_0.next;
}